import type { TOC } from '@ember/component/template-only';

import GenieArtifactsComponent from 'webapp/components/genie/artifacts/index';

const ArtifactsRouteTemplate: TOC<object> = <template><GenieArtifactsComponent /></template>;

export default ArtifactsRouteTemplate;
